var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-no-results-spinner"},[_c('QSpinner',{attrs:{"size":"lg","color":"grey-7"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }